import { EventEmitter } from "events";
import { StandaloneModalState } from "./StandaloneModalContainer";

class StandaloneModalManager extends EventEmitter {
  constructor() {
    super();
    this.details = null;
  }

  details: StandaloneModalState["errorDetails"];

  create(details: StandaloneModalState["errorDetails"]) {
    this.details = details;
    this.emitChange();
  }

  remove() {
    this.details = null;
    this.emitChange();
  }

  emitChange() {
    this.emit("loading", this.details);
  }

  addChangeListener(callback) {
    this.addListener("loading", callback);
  }

  removeChangeListener(callback) {
    this.removeListener("loading", callback);
  }
}

export default new StandaloneModalManager();
